import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initA11y } from "./lib/a11y";

// Apply a11y settings BEFORE first paint so they persist across
// every route navigation without any visual flash.
initA11y();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
